module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Mentors",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M46.0237305,42.7370199 C46.0237305,42.9280599 40.1962891,45.0346883 40.1962891,55 C26.6022149,55 7.17912475,55 5,55 C5,43.8366699 9.00938495,34.2923521 18.5995594,30.4365191 C17.5912109,29.284668 14.6150391,25.7830811 14.6150391,20.0223796 C14.6150391,13.3143916 19.977644,5 29,5 C37.3938034,5 43.3365234,12.3539225 43.3365234,20.0223796 C43.3365234,26.9734701 39.4415044,30 39.4415044,30.4549123 C41.9315032,31.4624337 44.0442842,32.8543004 45.8074087,34.5589203 C43.4873047,38.6837769 46.0237305,42.461141 46.0237305,42.7370199 Z M65,55 C62.7389391,55 43.3321797,55 41.8,55 C41.8,49.6043905 43.7378694,44.9913035 48.3731204,43.1276509 C47.885752,42.5709229 46.4472689,40.8784892 46.4472689,38.0941501 C46.4472689,34.8519559 49.0391946,30.8333333 53.4,30.8333333 C57.457005,30.8333333 60.3293197,34.3877292 60.3293197,38.0941501 C60.3293197,41.4538439 58.4467271,42.9166667 58.4467271,43.136541 C63.0667836,45.0059416 65,49.6129499 65,55 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b2d9df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/mentors.vue
// module id = 601
// module chunks = 1